import { createBrowserHistory } from 'history'

let browserHistory
browserHistory = createBrowserHistory()

export default browserHistory